import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc0d4148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑入库货量 ", -1))
const _hoisted_3 = {
  key: 0,
  style: {"float":"left","min-width":"500px","margin-top":"-10px","width":"70%"}
}
const _hoisted_4 = {
  key: 0,
  style: {"padding-top":"0px","color":"red","font-size":"14px","margin-top":"-15px"}
}
const _hoisted_5 = {
  key: 1,
  style: {"float":"left","min-width":"500px","margin-top":"-10px","width":"70%"}
}
const _hoisted_6 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-6px","margin-right":"-10px"} }
const _hoisted_7 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_9 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_12 = ["title"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_14 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_19 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_20 = ["title"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "cm", -1))
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_24 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_25 = ["title"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "KGS", -1))
const _hoisted_27 = ["title"]
const _hoisted_28 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_29 = ["title"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "CBM", -1))
const _hoisted_31 = ["title"]
const _hoisted_32 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_33 = ["title"]
const _hoisted_34 = ["title"]
const _hoisted_35 = {
  key: 0,
  style: {"padding-left":"5px","padding-right":"5px"}
}
const _hoisted_36 = {
  key: 1,
  style: {"padding-left":"5px","padding-right":"5px"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_38 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_39 = ["title"]
const _hoisted_40 = ["title"]
const _hoisted_41 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_42 = ["title"]
const _hoisted_43 = ["title"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 0,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","padding-top":"15px"}
}
const _hoisted_46 = { style: {"clear":"both","margin-top":"30px"} }
const _hoisted_47 = { style: {"float":"left","width":"95%"} }
const _hoisted_48 = { style: {"float":"left"} }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_51 = { style: {"float":"left","width":"95%"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " KGS ", -1))
const _hoisted_53 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_54 = { style: {"float":"left","width":"95%"} }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }, " m³ ", -1))
const _hoisted_56 = {
  key: 0,
  style: {"float":"left","width":"100%","font-size":"14px","color":"red"}
}
const _hoisted_57 = { style: {"padding":"0px","text-align":"center","margin":"0px","padding-left":"20px","padding-right":"20px"} }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "计划货量", -1))
const _hoisted_63 = {
  key: 0,
  style: {"float":"left","width":"70%","margin-top":"10px","margin-left":"20px"}
}
const _hoisted_64 = { style: {"float":"left","margin-right":"20px"} }
const _hoisted_65 = { style: {"float":"left","margin-right":"10px"} }
const _hoisted_66 = { style: {"float":"left","margin-right":"10px"} }
const _hoisted_67 = { style: {"float":"right"} }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = ["title"]
const _hoisted_70 = ["title"]
const _hoisted_71 = ["title"]
const _hoisted_72 = ["title"]
const _hoisted_73 = ["title"]
const _hoisted_74 = ["title"]
const _hoisted_75 = ["title"]
const _hoisted_76 = ["title"]
const _hoisted_77 = {
  key: 1,
  style: {"clear":"both","margin-top":"30px"}
}
const _hoisted_78 = { style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"} }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, " 装货港出库货量 ", -1))
const _hoisted_80 = { style: {"clear":"both","height":"30px","overflow":"hidden"} }
const _hoisted_81 = { style: {"clear":"both","height":"25px","padding-top":"3px","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.ruleForm.Visible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ruleForm.Visible) = $event)),
      top: "20px",
      "show-close": false,
      style: {"width":"96%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_2,
        (_ctx.list.Data.IsNewCharge == true && _ctx.isDetail!=true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 10 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "计费类型",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_miezz_select, {
                            modelValue: _ctx.list.Data.ChargeType,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.list.Data.ChargeType) = $event)),
                            onChange: _ctx.onChangeType,
                            options: _ctx.types,
                            clearable: false,
                            disabled: !_ctx.list.Data.IsSelectChargeWeight
                          }, null, 8, ["modelValue", "onChange", "options", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 14 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "规则",
                        "label-width": "70px"
                      }, {
                        default: _withCtx(() => [
                          (_ctx.list.Data.ChargeType == 10)
                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 0,
                                modelValue: _ctx.list.Data.CompanyChargeId,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.list.Data.CompanyChargeId) = $event)),
                                clearable: false,
                                options: _ctx.list.Data.Weights,
                                onChange: _ctx.onChangeChargeWeight,
                                onClear: _ctx.onChangeWeight,
                                disabled: !_ctx.list.Data.IsSelectChargeWeight
                              }, null, 8, ["modelValue", "options", "onChange", "onClear", "disabled"]))
                            : _createCommentVNode("", true),
                          (_ctx.list.Data.ChargeType == 20)
                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 1,
                                modelValue: _ctx.list.Data.CompanyChargeId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.list.Data.CompanyChargeId) = $event)),
                                clearable: false,
                                options: _ctx.list.Data.Volumes,
                                onChange: _ctx.onChangeChargeVolume,
                                onClear: _ctx.onChangeVolume,
                                disabled: !_ctx.list.Data.IsSelectChargeWeight
                              }, null, 8, ["modelValue", "options", "onChange", "onClear", "disabled"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.list.Data.IsSelectChargeWeight == true && _ctx.isDetail!=true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 当前服务内容：" + _toDisplayString(_ctx.list.Data.CurrentServiceRemark) + "未关联计费规则，请手动选择合适的规则 ", 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.list.Data.IsNewCharge == true && _ctx.isDetail==true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 4 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "计费类型",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isString(_ctx.list.Data.ChargeTypeString)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "规则",
                        "label-width": "70px"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isString(_ctx.list.Data.CompanyChargeString)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormInStock",
          model: _ctx.list,
          "label-width": "150px",
          rules: _ctx.customsPackageTableRules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_table, {
                ref: "customsPackageTable",
                data: _ctx.list.Data.Items,
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    type: "index",
                    label: "序号",
                    width: "60"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: '序号',
                          tooltip: true
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { prop: "Leng" }, {
                    header: _withCtx(() => [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: 'L/φ（长度（最长边）/直径）（cm）',
                          tooltip: true,
                          className: 'Leng'
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.Length
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.Length',
                              rules: _ctx.customsPackageTableRules.Length
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: scope.row.IsOutStock==true?true:false,
                                  title: scope.row.IsOutStock==true?'已有出库记录，无法修改':'',
                                  modelValue: scope.row.Length,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Length) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeLength(scope.$index))
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_11
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "title", "modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ], 8, _hoisted_10))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Length
                          }, _toDisplayString(scope.row.Length), 9, _hoisted_12))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, { prop: "Width" }, {
                    header: _withCtx(() => [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: 'W/φ（宽度（第二长边）/直径）（cm）',
                          tooltip: true,
                          className: 'Width'
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.Width
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.Width',
                              rules: _ctx.customsPackageTableRules.Width
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: scope.row.IsOutStock==true?true:false,
                                  title: scope.row.IsOutStock==true?'已有出库记录，无法修改':'',
                                  modelValue: scope.row.Width,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Width) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeWidth(scope.$index))
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_16
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "title", "modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ], 8, _hoisted_15))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Width
                          }, _toDisplayString(scope.row.Width), 9, _hoisted_17))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Height",
                    label: "高cm"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: 'H（高度/最短边）（cm）',
                          tooltip: true,
                          className: 'Height'
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.Height
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.Height',
                              rules: _ctx.customsPackageTableRules.Height
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: scope.row.IsOutStock==true?true:false,
                                  title: scope.row.IsOutStock==true?'已有出库记录，无法修改':'',
                                  modelValue: scope.row.Height,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Height) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeHeight(scope.$index))
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_21
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "title", "modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ], 8, _hoisted_20))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Height
                          }, _toDisplayString(scope.row.Height), 9, _hoisted_22))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "GrossWeight",
                    label: "单件毛重KGS"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_23,
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: '单件毛重KGS',
                          tooltip: true,
                          className: 'GrossWeight'
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.GrossWeight
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.GrossWeight',
                              rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: scope.row.IsOutStock==true?true:false,
                                  title: scope.row.IsOutStock==true?'已有出库记录，无法修改':'',
                                  modelValue: scope.row.GrossWeight,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.GrossWeight) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeGrossWeight(scope.$index))
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_26
                                  ]),
                                  _: 2
                                }, 1032, ["disabled", "title", "modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop"])
                          ], 8, _hoisted_25))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.GrossWeight
                          }, _toDisplayString(scope.row.GrossWeight), 9, _hoisted_27))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "Volume",
                    label: "单件体积CBM",
                    width: "230px"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: '单件体积CBM',
                          tooltip: true
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.Volume
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.Volume',
                              rules: _ctx.customsPackageTableRules.Volume
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: true,
                                  modelValue: scope.row.Volume,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.Volume) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeVolume(scope.$index))
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_30
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ], 8, _hoisted_29))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Volume
                          }, _toDisplayString(scope.row.Volume), 9, _hoisted_31))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    width: "180px",
                    prop: "ChargeWeight",
                    label: _ctx.list.Data.ChargeType==10?'单件计费标准KGS':'单件计费标准CBM'
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: _ctx.list.Data.ChargeType==10?'单件计费标准KGS':'单件计费标准CBM',
                          tooltip: true
                        }, null, 8, ["text"])
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail==true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.ChargeWeight
                          }, _toDisplayString(_ctx.isString(scope.row.ChargeWeight)), 9, _hoisted_33))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.ChargeWeight
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: true,
                                  modelValue: scope.row.ChargeWeight,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.ChargeWeight) = $event)
                                }, {
                                  append: _withCtx(() => [
                                    (_ctx.list.Data.ChargeType==10)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, " KGS "))
                                      : (_ctx.list.Data.ChargeType==20)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, " CBM "))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024)
                          ], 8, _hoisted_34))
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_table_column, {
                    prop: "InStockQuantity",
                    label: "入库数量",
                    width: "200px"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: '入库数量',
                          tooltip: true,
                          className: 'InStockQuantity'
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.InStockQuantity
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: "",
                              prop: 'Data.Items.' + scope.$index + '.InStockQuantity',
                              rules: _ctx.customsPackageTableRules.InStockQuantity
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_miezz_input, {
                                  placeholder: "请填写",
                                  disabled: _ctx.list.Data.IsShiftout==true?true:false,
                                  modelValue: scope.row.InStockQuantity,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.InStockQuantity) = $event),
                                  onBlur: ($event: any) => (_ctx.onChangeInStockQuantity(scope.$index))
                                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onBlur"])
                              ]),
                              _: 2
                            }, 1032, ["prop", "rules"])
                          ], 8, _hoisted_39))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.InStockQuantity
                          }, _toDisplayString(scope.row.InStockQuantity), 9, _hoisted_40))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "InStockTime",
                    label: "入库日期"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_miezz_text_ellipsis, {
                          text: '入库日期',
                          tooltip: true,
                          className: 'InStockTime'
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            style: {"width":"100% !important","overflow":"hidden","height":"46px"},
                            title: scope.row.InStockTime
                          }, [
                            _createVNode(_component_el_form_item, {
                              "label-width": "0px",
                              label: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: scope.row.InStockTime,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.InStockTime) = $event),
                                  type: "datetime",
                                  disabled: _ctx.list.Data.IsShiftout==true?true:false,
                                  placeholder: "请选择",
                                  format: "YYYY/MM/DD HH:mm",
                                  "default-time": _ctx.defaultTime
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "default-time"])
                              ]),
                              _: 2
                            }, 1024)
                          ], 8, _hoisted_42))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.InStockTime
                          }, _toDisplayString(scope.row.InStockTime), 9, _hoisted_43))
                    ]),
                    _: 1
                  }),
                  (_ctx.isDetail!=true)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        label: "操作",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.onDelete(scope.$index)),
                            title: "删除"
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Delete)
                              ]),
                              _: 1
                            })
                          ], 8, _hoisted_44)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "onSelectionChange"]),
              (_ctx.isDetail!=true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("span", {
                      style: {"cursor":"pointer"},
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAdd && _ctx.onAdd(...args)))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" 添加")
                    ]),
                    _createElementVNode("span", {
                      style: {"cursor":"pointer","margin-left":"15px","display":"none"},
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onBatchDelete && _ctx.onBatchDelete(...args)))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Delete)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" 删除")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_el_row, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: _ctx.list.Data.IsNewCharge == true?6:8
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "合计件数",
                            prop: "Data.SumQuantityInStock",
                            rules: [
                                                          {
                                                            required: true,
                                                            message: '信息不能为空',
                                                            trigger: 'blur',
                                                          },
                                                        ]
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_47, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.list.Data.SumQuantityInStock,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.list.Data.SumQuantityInStock) = $event)),
                                  disabled: _ctx.isSum==true?false:true,
                                  class: "input-with-select",
                                  onBlur: _ctx.onChangeSumQuantity
                                }, {
                                  append: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.list.Data.ChargeUnitInStock,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.list.Data.ChargeUnitInStock) = $event)),
                                      style: {"width":"100% !important","background-color":"#fff"},
                                      filterable: "",
                                      "allow-create": "",
                                      "default-first-option": "",
                                      "reserve-keyword": false,
                                      placeholder: "请选择"
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageEnHistorys, (item, index) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.Label,
                                            label: item.Label,
                                            value: item.Label
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", _hoisted_48, _toDisplayString(item.Label), 1),
                                              (item.Data.IsHistory==true)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                                    onClick: ($event: any) => (_ctx.onDeletePackageEn(item.Value,index))
                                                  }, [
                                                    _createVNode(_component_el_icon, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_Delete)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ], 8, _hoisted_49))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1032, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled", "onBlur"]),
                                (_ctx.list.Data.SumQuantityInStock!=null && _ctx.list.Data.SumQuantityInStock!=undefined && _ctx.list.Data.SumQuantityInStock != _ctx.list.Data.SumQuantity)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, " 计划货量与入库货量的合计件数不一致 "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "合计件数"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.list.Data.SumQuantityInStock) + _toDisplayString(_ctx.list.Data.ChargeUnitInStock), 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["span"]),
                  _createVNode(_component_el_col, {
                    span: _ctx.list.Data.IsNewCharge == true?6:8
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "合计毛重"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.list.Data.SumGrossWeightInStock,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.list.Data.SumGrossWeightInStock) = $event)),
                                  onBlur: _ctx.onChangeSumGrossWeight,
                                  disabled: _ctx.isSum==true?false:true
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_52
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onBlur", "disabled"]),
                                (_ctx.list.Data.SumGrossWeightInStock!=null && _ctx.list.Data.SumGrossWeightInStock!=undefined && _ctx.list.Data.SumGrossWeightInStock != _ctx.list.Data.SumGrossWeight)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, " 计划货量与入库货量的合计毛重不一致 "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "合计毛重"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.list.Data.SumGrossWeightInStock) + "KGS ", 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["span"]),
                  _createVNode(_component_el_col, {
                    span: _ctx.list.Data.IsNewCharge == true?6:8
                  }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "合计体积"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_54, [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.list.Data.SumVolumeInStock,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.list.Data.SumVolumeInStock) = $event)),
                                  onBlur: _ctx.onChangeSumVolume,
                                  disabled: _ctx.isSum==true?false:true
                                }, {
                                  append: _withCtx(() => [
                                    _hoisted_55
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "onBlur", "disabled"]),
                                (_ctx.list.Data.SumVolumeInStock!=null && _ctx.list.Data.SumVolumeInStock!=undefined && _ctx.list.Data.SumVolumeInStock != _ctx.list.Data.SumVolume)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, " 计划货量与入库货量的合计体积不一致 "))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "合计体积"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.list.Data.SumVolumeInStock) + "m³ ", 1)
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }, 8, ["span"]),
                  (_ctx.list.Data.IsNewCharge == true)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 6
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isDetail!=true)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                label: _ctx.list.Data.ChargeType==10?'合计计费重量':'合计计费体积'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.list.Data.ChargeWeight,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.list.Data.ChargeWeight) = $event)),
                                    disabled: true
                                  }, {
                                    append: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_57, [
                                        (_ctx.list.Data.ChargeType==10)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_58, "KGS"))
                                          : (_ctx.list.Data.ChargeType==20)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_59, "CBM"))
                                            : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                label: _ctx.list.Data.ChargeType==10?'合计计费重量':'合计计费体积'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.isString(_ctx.list.Data.ChargeWeight)) + " ", 1),
                                  (_ctx.list.Data.ChargeType==10)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_60, "KGS"))
                                    : (_ctx.list.Data.ChargeType==20)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, "CBM"))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["label"]))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "备注"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.list.Data.RemarkInStock,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.list.Data.RemarkInStock) = $event)),
                                rows: 5,
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "备注"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.list.Data.RemarkInStock,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.list.Data.RemarkInStock) = $event)),
                                rows: 5,
                                disabled: true,
                                type: "textarea"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"]),
        _createVNode(_component_el_card, { style: {"margin-top":"20px"} }, {
          header: _withCtx(() => [
            _createElementVNode("div", {
              style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isPlan = !_ctx.isPlan))
            }, [
              _hoisted_62,
              (_ctx.isPlan==true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_el_form_item, { label: "合计件数" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.plan.Data.SumQuantity) + _toDisplayString(_ctx.plan.Data.ChargeUnit), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createVNode(_component_el_form_item, { label: "合计毛重" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.plan.Data.SumGrossWeight) + "KGS ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createVNode(_component_el_form_item, { label: "合计体积" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.plan.Data.SumVolume) + "m³ ", 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_67, [
                (_ctx.isPlan==false)
                  ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowDownBold)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ArrowUpBold)
                      ]),
                      _: 1
                    }))
              ])
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.isPlan==false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                  _createVNode(_component_el_table, {
                    data: _ctx.plan.Data.Items
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "Leng",
                        width: "160",
                        label: "长cm"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                            title: scope.row.Length
                          }, _toDisplayString(_ctx.isString(scope.row.Length)), 9, _hoisted_69)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Width",
                        label: "宽cm",
                        width: "160"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","height":"26px","line-height":"26px"},
                            title: scope.row.Width
                          }, _toDisplayString(_ctx.isString(scope.row.Width)), 9, _hoisted_70)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Height",
                        label: "高cm",
                        width: "160"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Height
                          }, _toDisplayString(_ctx.isString(scope.row.Height)), 9, _hoisted_71)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "GrossWeight",
                        label: "单件毛重KGS"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.GrossWeight
                          }, _toDisplayString(_ctx.isString(scope.row.GrossWeight)), 9, _hoisted_72)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "Volume",
                        label: "单件体积CBM"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.Volume
                          }, _toDisplayString(_ctx.isString(scope.row.Volume)), 9, _hoisted_73)
                        ]),
                        _: 1
                      }),
                      (_ctx.orderDepartureWharfId!=null&&_ctx.orderDepartureWharfId!=undefined&&_ctx.orderDepartureWharfId!='' || _ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            prop: "Quantity",
                            label: "数量"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.Quantity
                              }, _toDisplayString(_ctx.isString(scope.row.Quantity)), 9, _hoisted_74)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.orderDepartureWharfId!=null&&_ctx.orderDepartureWharfId!=undefined&&_ctx.orderDepartureWharfId!='' || _ctx.isDetail!=true)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 1,
                            prop: "SurplusQuantity",
                            label: "剩余数量"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("div", {
                                style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                                title: scope.row.SurplusQuantity
                              }, _toDisplayString(scope.row.SurplusQuantity), 9, _hoisted_75)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, {
                        prop: "DeliveryQuantity",
                        label: "送货数量"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("div", {
                            style: {"width":"100% !important","overflow":"hidden","height":"26px","line-height":"26px"},
                            title: scope.row.DeliveryQuantity
                          }, _toDisplayString(scope.row.DeliveryQuantity), 9, _hoisted_76)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPlan==false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                  _createVNode(_component_el_row, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计件数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumQuantity) + _toDisplayString(_ctx.plan.Data.ChargeUnit), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计毛重" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumGrossWeight) + "KGS ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计体积" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumVolume) + "m³ ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.plan.Data.IsDepartureOutStock == true )
          ? (_openBlock(), _createBlock(_component_el_card, {
              key: 0,
              style: {"margin-top":"20px"}
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_78, [
                  _hoisted_79,
                  _createElementVNode("div", {
                    style: {"float":"right","cursor":"pointer","font-weight":"400","color":"#fe995b"},
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onDepartureDetail()))
                  }, " 查看详情 ")
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_el_row, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计件数" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumQuantityOutStock) + _toDisplayString(_ctx.plan.Data.ChargeUnitOutStock), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计毛重" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumGrossWeightOutStock) + "KGS ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "合计体积" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.plan.Data.SumVolumeOutStock) + "m³ ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_81, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.bottomButtons,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClick
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [
      _directive_loading,
      _ctx.isLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}